// @ts-check

/**
 * @file Persists the selected frontend locale in the local Option model.
 */

import Option from "../models/option"
import {flushLocalDatabaseWrites} from "./local-database-persistence"

/**
 * Locale persistence backed by the local Velocious `Option` SQLite
 * table. The persisted value is the source of truth between cold
 * boots so a window refresh doesn't fall back to the device language
 * once the user has settled on a locale.
 */

const STORAGE_KEY = "locale"

/**
 * Reads the persisted locale value.
 * @returns {Promise<string | null>} Stored locale code when one exists.
 */
export async function getStoredLocale() {
  const option = await Option.findBy({key: STORAGE_KEY})

  return option?.value() || null
}

/**
 * Persists the selected locale value.
 * @param {string} locale Locale code to store.
 * @returns {Promise<void>}
 */
export async function saveStoredLocale(locale) {
  const option = await Option.findOrInitializeBy({key: STORAGE_KEY})

  option.assign({value: locale})
  await option.save()
  await flushLocalDatabaseWrites()
}
